import { render, staticRenderFns } from "./ModalCancelOrder.vue?vue&type=template&id=0c641bf8&scoped=true&"
import script from "./ModalCancelOrder.vue?vue&type=script&lang=js&"
export * from "./ModalCancelOrder.vue?vue&type=script&lang=js&"
import style0 from "./ModalCancelOrder.vue?vue&type=style&index=0&id=0c641bf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c641bf8",
  null
  
)

export default component.exports